import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

export default function Contact() {
    return (
        <div className="page">
            <div className="container">

                <h1>Contact Us</h1>

                <p className="subtitle">
                    Questions about Adult Family Homes? We're here to help.
                </p>

                <div className="contact-grid">

                    {/* CONTACT FORM */}
                    <form className="contact-form">

                        <input type="text" placeholder="Your Name" required />

                        <input type="email" placeholder="Email Address" required />

                        <textarea rows="5" placeholder="Your Message" required />

                        <button type="submit">
                            Send Message
                        </button>

                    </form>

                    {/* CONTACT INFO */}
                    <div className="contact-info">

                        <h3>Washington AFH</h3>

                        <p>
                            A platform helping families find trusted Adult Family Homes.
                        </p>

                        <div className="contact-item">
                            <FaMapMarkerAlt /> Washington State
                        </div>

                        <div className="contact-item">
                            <FaPhone /> (206) 555-1234
                        </div>

                        <div className="contact-item">
                            <FaEnvelope /> info@washingtonafh.com
                        </div>

                    </div>

                </div>

            </div>
        </div>
    );
}